import { axisBottom, axisLeft, axisRight } from 'd3-axis'
import { select, Selection } from 'd3-selection'
import timeFormat from './timeFormat'
import { ScaleLinear } from 'd3'
import { Span } from '../../types'
import AxisService from 'live/services/charts/axis'

export default function liveAxis(
    selection: Selection<null, null, Element, null>,
    scale: ScaleLinear<number, number>,
    vertical: boolean,
    type: 'time' | 'depth',
    axisWidth: number,
    internalAxis: boolean,
    span: Span,
    isRealtime: boolean
): void {
    const { min, max } = AxisService.getDomainScale(
        span.begin === undefined ? span.start : span.begin,
        span.end,
        isRealtime
    )

    const textAnchor = vertical ? (internalAxis ? 'start' : 'end') : 'middle'

    scale.domain([min, max])
    let axis = vertical
        ? internalAxis
            ? axisRight(scale).tickFormat(type === 'time' ? timeFormat : null)
            : axisLeft(scale).tickFormat(type === 'time' ? timeFormat : null)
        : axisBottom(scale).tickFormat(type === 'time' ? timeFormat : null)

    const range = vertical ? [scale(min), scale(max) + 11] : [scale(min), scale(max)]
    const tickPositions = AxisService.getDateTimeTickPositions([min, max], range, vertical)
    axis = axis.tickValues(tickPositions)

    selection.attr('text-anchor', textAnchor)
    const s = selection.call(axis)

    if (vertical && axisWidth < 65 && !internalAxis) {
        const textMargin = internalAxis ? 9 : -9
        s.selectAll('.tick text').call(function (group) {
            group.each(function () {
                const self = select(this)
                const text = self.text().trim().split(' ')
                if (text.length > 1) {
                    self.text('')
                    self.append('tspan').attr('x', textMargin).attr('dy', 0).text(text[0])
                    self.append('tspan').attr('x', textMargin).attr('dy', '1.1em').text(text[1])
                }
            })
        })
    }
}
